import { Box, Button, ButtonGroup, Grid, WithStyles } from "@material-ui/core";
import { FormikProps } from "formik";
import React from "react";
import { Person } from "../../../model/Person";
import { ApiBackend } from "../../../providers/apibackend";
import RenderPersonFields from "./RenderPersonFields";
import EditPersonActions from "./EditPersonActions/EditPersonActions";

interface IProps extends FormikProps<Person> {
    isEditMode: boolean;
}

class EditPersonFormContent extends React.Component<WithStyles & IProps> {
    private readonly apiBackend: ApiBackend;

    constructor(props: WithStyles & IProps) {
        super(props);

        this.apiBackend = new ApiBackend();
    }

    render(): JSX.Element {
        const { isEditMode, classes, values } = this.props;

        const defaultBoxStyle = {
            display: "flex",
            flexDirection: "row",
        };

        return (
            <Grid container className={classes.root} spacing={2} style={{ width: "100%", position: "relative" }}>
                <Grid item xs={12}>
                    <Grid container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                    >
                        {values.counters && values.counters.some(x => x.counter_key == "MJ") &&
                            <Grid item xs={6}>
                                <div style={{ left: 0, top: 0, fontSize: 12, position: "absolute", textAlign: "center" }}>
                                    Medaljår
                                    <div style={{ background: "gold", height: 50, width: 50, borderRadius: 50, lineHeight: "50px", fontWeight: "bolder", border: "3px solid saddlebrown", fontSize: 20 }}>
                                        {values.counters?.find(x => x.counter_key == "MJ")?.count}st
                                    </div>
                                </div>
                            </Grid>
                        }
                        {isEditMode &&
                            <Box style={{ paddingBottom: 16, display: "flex", flexDirection: "column", width: "100%" }}>
                                <Box {...defaultBoxStyle} style={{ gap: "16px", marginLeft: "auto" }}>
                                    <EditPersonActions {...this.props} />
                                </Box>
                            </Box>
                        }
                    </Grid>
                </Grid>
                <RenderPersonFields {...this.props} />
            </Grid>
        )
    }
}

export default EditPersonFormContent;
